import { render, staticRenderFns } from "./CustomerActivityReport.vue?vue&type=template&id=40a71066&"
import script from "./CustomerActivityReport.vue?vue&type=script&lang=js&"
export * from "./CustomerActivityReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports